module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cball"
  }, [_c('div', [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "min-height": "470px",
      "padding": "50px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticClass: "flex justify-between align-center flex-wrap"
  }, _vm._l((_vm.config.collect_code), function(item, index) {
    return _c('el-image', {
      key: index,
      staticClass: "qrimg",
      attrs: {
        "src": _vm._f("addurl")(item),
        "fit": "cover"
      }
    })
  }), 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rtitle flex justify-between align-center bg-white rone"
  }, [_c('div', {
    staticClass: "colorleft"
  }, [_vm._v("缴费方式")]), _vm._v(" "), _c('div', {
    staticClass: "colorright"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-822f19f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mine/payment_way.vue
// module id = 410
// module chunks = 1